import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Spinner from "../../components/spinner/Spinner";
import { GetCampaign, GetCampaignReports, GetReportSettings, GetSEOReportMapEmbed } from "../../Services";
import "../publicViewCampaignReportV5/PublicViewCampaignReportScreenV5.css";
import GridReportMapEmbed from "./GridReportMapEmbed";
import { getCached, setCached } from "../../reportCache";

const PublicViewGridReportMapEmbed = () => {
    const [isLoadingReport, setIsLoadingReport] = useState(true);
    const { campaignId, reportId, keyword } = useParams();
    const [campaign, setCampaign] = useState();
    const [report, setReport] = useState();
    const [reportIdValue, setReportIdValue] = useState();
    const [targetKeyword, setTargetKeyword] = useState();
    const [reportSettingsFormData, setReportSettingsFormData] = useState({});

    useEffect(() => {
        if (campaignId) {
            getCampaign(campaignId);
        }
    }, [campaignId]);

    useEffect(() => {
        if (campaign) {
            getCampaignReports();
            getReportSettings();
        }
    }, [campaign]);

    useEffect(() => {
        if (reportIdValue) {
            getReport(reportIdValue);
        }
    }, [reportIdValue]);

    const getCampaign = async (id) => {
        const response = await GetCampaign(id);

        if (response) {
            setCampaign(response);
        }
    };

    const getCampaignReports = async () => {
        if (campaign) {
            const response = await GetCampaignReports(campaign.id);

            if (response && response.reports && response.reports.length > 0) {
                setReportIdValue(reportId);
            } else {
                setIsLoadingReport(false);
            }
        }
    };

    const getReport = async (id) => {
        setIsLoadingReport(true);

        if (campaign) {
            let response = await GetSEOReportMapEmbed(campaign.id, id);

            if (response.success && response.data && response.data.length > 0) {
                let reports = response.data;

                let tempReport = reports[0];
                tempReport.reportId = id;

                setReport(tempReport);

                if (tempReport.gridResponse && tempReport.gridResponse.data && tempReport.gridResponse.data.length > 0) {
                    let keywordData = tempReport.gridResponse.data.find((k) => k.keyword.toLowerCase() === keyword.toLowerCase());

                    setTargetKeyword({
                        lat: tempReport.gridResponse.lat,
                        lng: tempReport.gridResponse.lng,
                        horizontalPoints: tempReport.gridResponse.horizontalPoints,
                        verticalPoints: tempReport.gridResponse.verticalPoints,
                        ...keywordData,
                    });
                }

                setIsLoadingReport(false);
            } else {
                setReport();
                setReportIdValue();
            }
        }
    };

    const getReportWithCache = async (id) => {
        setIsLoadingReport(true);

        if (campaign) {
            //console.log("GET key:", campaign.id, "|", id);
            const cachedResponse = await getCached(campaign.id, id);
            console.log("cache hit:", !!cachedResponse, "| value:", cachedResponse);

            if (cachedResponse) {
                if (cachedResponse.success && cachedResponse.data && cachedResponse.data.length > 0) {
                    let reports = cachedResponse.data;

                    let tempReport = reports[0];
                    tempReport.reportId = id;

                    setReport(tempReport);

                    if (tempReport.gridResponse && tempReport.gridResponse.data && tempReport.gridResponse.data.length > 0) {
                        let keywordData = tempReport.gridResponse.data.find((k) => k.keyword.toLowerCase() === keyword.toLowerCase());

                        setTargetKeyword({
                            lat: tempReport.gridResponse.lat,
                            lng: tempReport.gridResponse.lng,
                            horizontalPoints: tempReport.gridResponse.horizontalPoints,
                            verticalPoints: tempReport.gridResponse.verticalPoints,
                            ...keywordData,
                        });
                    }

                    setIsLoadingReport(false);
                } else {
                    setReport();
                    setReportIdValue();
                }
            } else {
                let response = await GetSEOReportMapEmbed(campaign.id, id);

                if (response.success && response.data && response.data.length > 0) {
                    let reports = response.data;

                    let tempReport = reports[0];
                    tempReport.reportId = id;

                    setReport(tempReport);

                    if (tempReport.gridResponse && tempReport.gridResponse.data && tempReport.gridResponse.data.length > 0) {
                        let keywordData = tempReport.gridResponse.data.find((k) => k.keyword.toLowerCase() === keyword.toLowerCase());

                        setTargetKeyword({
                            lat: tempReport.gridResponse.lat,
                            lng: tempReport.gridResponse.lng,
                            horizontalPoints: tempReport.gridResponse.horizontalPoints,
                            verticalPoints: tempReport.gridResponse.verticalPoints,
                            ...keywordData,
                        });
                    }

                    setIsLoadingReport(false);
                } else {
                    setReport();
                    setReportIdValue();
                }

                //console.log("SET key:", campaign.id, "|", id);
                setCached(campaign.id, id, response);
            }
        }
    };

    const getReportSettings = async () => {
        let response = await GetReportSettings();

        if (response && response.data) {
            setReportSettingsFormData(response.data);
        }
    };

    return (
        <div className="campaign-v-p-report-v5 p-0 text-start">
            {isLoadingReport && (
                <div className="text-center">
                    <Spinner />
                </div>
            )}

            {!isLoadingReport && (
                <Fragment>
                    {report && report.gridResponse && report.gridResponse.data && (
                        <Fragment>
                            <GridReportMapEmbed
                                key="map-0"
                                gridData={targetKeyword}
                                placeId={campaign.googlePlaceId}
                                placeCid={campaign.googleCid}
                                reportSettings={reportSettingsFormData}
                            />
                        </Fragment>
                    )}
                </Fragment>
            )}
        </div>
    );
};

export default PublicViewGridReportMapEmbed;
